export default __webpack_public_path__ + "static/product13-2abad4278a81c95b404245f137d10021.jpg";